<template>
  <v-dialog
    :close-on-content-click="false"
    v-model="showSectionCreator"
    :fullscreen="$vuetify.breakpoint.xs"
    max-width="1864px"
  >
    <SectionCreator
      :reflection-id="reflection.id"
      :header-id="headerId"
      :existing-section-infos="existingSectionInfos"
      @close-section-creator="showSectionCreator = false"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { store } from 'editor-svelte';
import SectionCreator from '../../../journal/SectionCreator';
import { types } from '../../../../../store/rootTypes';

export default {
  name: 'JournalExtension',
  components: {
    SectionCreator,
  },
  data() {
    return {
      headerId: undefined,
      existingSectionInfos: undefined,
      showSectionCreator: false,
      unsubscribeReflectionSection: undefined,
    };
  },
  computed: {
    ...mapGetters({
      userReflectionJournals:
        types.recommendationBasedJournals.getters.userReflectionJournals,
      reflection: types.reflections.getters.reflection,
    }),
  },
  created() {
    this.unsubscribeReflectionSection = store.journalReflectionSection.reflectionSection.subscribe(
      message => {
        if (!message || !message.headerId) {
          console.warn('Invalid message received by JournalExtension', message);
          return;
        }
        this.headerId = message.headerId;
        this.reset();

        switch (message.type) {
          case 'open':
            this.openJournalSection();
            break;
          case 'archive':
            this.archiveJournalSection();
            break;
          default:
            throw new Error(`Unknowned message type ${message}`);
        }
      },
    );
  },
  destroyed() {
    if (this.unsubscribeReflectionSection) {
      this.unsubscribeReflectionSection();
    }
  },
  methods: {
    ...mapActions({
      archiveJournalSectionAction:
        types.recommendationBasedJournals.actions.archivePipelinedJournal,
    }),
    openJournalSection() {
      this.showSectionCreator = true;
    },
    archiveJournalSection() {
      if (this.existingSectionInfos && this.existingSectionInfos.journalId) {
        this.archiveJournalSectionAction({
          pipelinedJournalId: this.existingSectionInfos.journalId,
        });
      }
    },
    updateReflectionInfos() {
      if (!this.headerId) return;

      const journalSection = this.userReflectionJournals.find(
        j => j.journal.headerId === this.headerId,
      );
      if (!journalSection) return;

      this.existingSectionInfos = {
        journalId: journalSection.journal.id,
        title: journalSection.journal.title,
      };
    },
    reset() {
      this.showSectionCreator = false;
      this.existingSectionInfos = undefined;
      this.updateReflectionInfos();
    },
  },
  watch: {
    userReflectionJournals() {
      this.updateReflectionInfos();
    },
    reflection() {
      this.updateReflectionInfos();
    },
  },
};
</script>
